import { jsx as a } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { memo as u } from "../../../../../external/preact/compat/dist/compat.module.js";
import { useResponsiveViewport as t, mediaQueries as o } from "../../../../../hooks/useResponsiveViewport.js";
import c from "../../../../internal/FormFields/Select/Select.js";
const y = u(
  ({
    placeholder: i,
    selection: r,
    selectionOptions: e,
    updateSelection: l
  }) => {
    const s = t(o.down.xs), m = t(o.only.sm), n = t(o.only.md);
    return e && e.length > 1 ? /* @__PURE__ */ a(
      c,
      {
        onChange: l,
        filterable: !1,
        multiSelect: !0,
        placeholder: i,
        selected: r,
        withoutCollapseIndicator: !0,
        items: e,
        showOverlay: s,
        fitPosition: n || m
      }
    ) : null;
  }
);
export {
  y as default
};
